<!--店铺管理-->
<template>
  <div>
    <el-form ref="baseRef" :model="storeFront" :rules="rules" label-width="150px">
      <el-form-item  label="店铺名:" prop="title" >
        <el-input  style="width: 300px" v-model="storeFront.title"></el-input>
      </el-form-item>
      <el-form-item  label="门店电话:" prop="tel" >
        <el-input style="width: 300px" v-model="storeFront.tel" placeholder=""></el-input>
      </el-form-item>
      <el-form-item  label="门店类型:" prop="type" >
            <el-select v-model="storeFront.typeId" placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
      <el-form-item  label="店铺描述:" prop="descripe" >
        <el-input style="width: 450px"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="storeFront.descripe"
                  maxlength="100"
                  show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button type="primary" @click="handleSure()">确定</el-button>
    </div>
  </div>
</template>
<style>


</style>

<script>

import {typeList, } from "../../../api/storeFrontType";
  export default {
    name: 'StoreFrontDetail',
    props: {
      storeFront:Object
    },
    data() {
      return {
        typeOptions:[],
      }
    },
    mounted() {
      this.initTypeLiet()
    },
    methods: {

      initTypeLiet(){
        typeList().then(response => {
          this.typeOptions = response.data
        })
      },
      handleSure(){
        this.$emit('handleSure',this.storeFront);

      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/superadmin/components/StoreFrontDetail.vue